import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Firebase from 'firebase/app';

function SignInPage() {
  return (
    <section className="section">
      <div className="is-sign-in-up">
        <SignInForm />
      </div>
    </section>
  );
}

function SignInForm() {
  const navigate = useNavigate();

  const googleLogIn = () => {
    const provider = new Firebase.auth.GoogleAuthProvider();
    return Firebase.auth().signInWithPopup(provider)
      .then(() => {
        navigate('/dashboard');
      })
      .catch((error) => {
        console.error('could not sign in', error);
        navigate('/');
      });
  };

  return (
    <button onClick={googleLogIn} className="is-google-button">
      <i className="fab fa-google is-left-button-icon"></i>
      Sign in via Google
    </button>
  );
}

function SignInLink() {
  return (
    <p className="is-sign-in-text">
      Already have an account?
      {' '}
      <Link to="/signin" className="is-link">Sign in!</Link>
    </p>
  );
}

export default SignInPage;

export {
  SignInForm,
  SignInLink,
};
